import { render, staticRenderFns } from "./arti_list.vue?vue&type=template&id=6e591902&scoped=true"
import script from "./arti_list.vue?vue&type=script&lang=js"
export * from "./arti_list.vue?vue&type=script&lang=js"
import style0 from "./arti_list.vue?vue&type=style&index=0&id=6e591902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e591902",
  null
  
)

export default component.exports